import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RootElementNotFoundError } from "@frontend/shared/infrastructure/errors/bootstrap.errors";
import App from "./App";
import "./index.css";

import "@frontend/shared/features/porter/porter-callback.config";

const ROOT_ELEMENT_ID = "root";

const rootElement = document.getElementById(ROOT_ELEMENT_ID);
if (rootElement === null) throw new RootElementNotFoundError(ROOT_ELEMENT_ID);

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
